import Reveal from "../components/Reveal";
import { Sparkles, Users, HeartHandshake } from "lucide-react";

const BULLETS = [
  {
    icon: Sparkles,
    title: "Client-first, not lead-first",
    body: "Built around the client you already have, not the pipeline you don't. No deal stages you'll never use.",
  },
  {
    icon: HeartHandshake,
    title: "Onboarding is the star",
    body: "Intake, welcome documents, contracts and portal access are baked in — not bolted on with a third-party app.",
  },
  {
    icon: Users,
    title: "Made for how VAs actually work",
    body: "One workspace across every client. No context-switching, no half-full spreadsheets, no lost details.",
  },
];

export default function BuiltForVAs() {
  return (
    <section data-testid="built-for-vas" className="py-24 lg:py-32 bg-[#22384F] text-white overflow-hidden relative">
      <div
        aria-hidden="true"
        className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full opacity-30"
        style={{ background: "radial-gradient(closest-side, #E8712C, transparent)" }}
      />
      <div className="max-w-6xl mx-auto px-5 sm:px-8 relative grid lg:grid-cols-[1.1fr_1fr] gap-10 lg:gap-16 items-center">
        <div><Reveal className="max-w-2xl mb-14">
          <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#F0B67F] mb-3">
            Purpose-built
          </div>
          <h2 className="font-display font-extrabold text-[32px] sm:text-[44px] leading-[1.08] tracking-[-0.02em] mb-4">
            Not another complicated sales CRM.
          </h2>
          <p className="text-[16px] text-white/80 leading-relaxed">
            ClientDesk VA was designed around the day-to-day workflow of running
            a virtual assistant business. Bookings, tasks, forms and documents
            are first-class citizens — not afterthoughts stapled to a sales
            pipeline.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-1 gap-4">
          {BULLETS.map((b, i) => (
            <Reveal key={b.title} delay={i * 80}>
              <div className="p-6 rounded-2xl bg-white/[0.06] border border-white/[0.08] backdrop-blur-sm h-full">
                <b.icon size={22} strokeWidth={1.6} className="text-[#F0B67F] mb-3" />
                <h3 className="font-display font-bold text-[17px] tracking-[-0.01em] mb-1">
                  {b.title}
                </h3>
                <p className="text-[14px] text-white/75 leading-relaxed">{b.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
        </div>
        <Reveal delay={140}>
          {/* Illustrative photograph — not a customer testimonial. */}
          <img
            src="/marketing/built_for_vas_pair.webp"
            alt="Illustrative photo of two independent professionals collaborating in a home office."
            loading="lazy"
            decoding="async"
            className="rounded-3xl w-full shadow-[0_30px_60px_-30px_rgba(0,0,0,0.6)]"
          />
        </Reveal>
      </div>
    </section>
  );
}
